/* MUI */
import { Typography } from '@mui/material';

/* Shared */
import { Percentage } from 'application/Shared/Components/Text';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { Trans } from 'react-i18next';

const MakeItBigger = ({ percent }) => (
    <Typography
        variant="p"
        style={{
            fontSize: FontSizes[2],
            fontWeight: 600
        }}
        data-testid="kpiPercentSubtitleMakeItBigger"
    >
        <Percentage percent={percent} />
    </Typography>
);

export const PercentSubtitle = ({ color, percentOfTotalMonthlyValue }) => (
    <Typography
        variant="p"
        style={{
            color,
            fontSize: FontSizes[0],
            fontWeight: 400,
            textTransform: 'uppercase'
        }}
        data-testid="kpiPercentSubtitle"
    >
        <Trans
            i18nKey="Reports.Contracts.percentOfTotalMonthlyValue"
            components={{
                Percent: <MakeItBigger percent={percentOfTotalMonthlyValue} />
            }}
        />
    </Typography>
);
